module.exports = __webpack_public_path__ + "media/advent.0ea3f7a5.mp4";